import {useContext} from 'react';
import {FlagContext} from '@unleash/proxy-client-react';
import resolveAffiliateAdPartners from './resolveAffiliateAdPartners';

const useAffiliateAdPartners = flagName => {
  const {isEnabled, getVariant} = useContext(FlagContext);

  return resolveAffiliateAdPartners(isEnabled(flagName), getVariant(flagName));
};

export default useAffiliateAdPartners;
